module.exports = __webpack_public_path__ + "static/media/it-icon.d9242099.png";